import './PageHeader.css';

// `actions` puts a page-level control (an upload/create button) on the same
// baseline as the title. Floating it separately above the content reads as
// disconnected from the page it belongs to.
export default function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="page-header">
      <div className="page-header-row">
        <h1>{title}</h1>
        {actions && <div className="page-header-actions">{actions}</div>}
      </div>
      {subtitle && <p>{subtitle}</p>}
    </div>
  );
}
